import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
  name: "category",
  initialState: "",
  reducers: {
    filterCategory(state, action) {
      return action.payload;
    },
    resetCategory(state, action) {
      return null;
    },
  },
});

export const { filterCategory, resetCategory } = categorySlice.actions;

export default categorySlice.reducer;
